import PropTypes from 'prop-types';
import React from 'react';
import { Link } from '../utils/router/v3Bridge';
import Badge from '../components/Badge';
import TopicShape from '../propTypes/TopicShape';
import topicPath from '../utils/url/topicPath';
import styles from './ContentMapColumnHeader.module.scss';
import TopicNameWithIcon from './TopicNameWithIcon';

const propTypes = {
  movedIn: PropTypes.bool.isRequired,
  name: PropTypes.string,
  link: PropTypes.bool,
  topic: TopicShape.isRequired,
};

const defaultProps = {
  name: null,
  link: null,
};

const ContentMapColumnHeader = ({ movedIn, name, link, topic }) => {
  const children = (
    <div className={styles.name}>
      <TopicNameWithIcon topic={topic} name={name} truncate="single" />
      {movedIn && (
        <div className={styles.badgeContainer}>
          <Badge color="pink">Moved</Badge>
        </div>
      )}
    </div>
  );

  return link ? (
    <Link className={styles.container} to={topicPath(topic)}>
      {children}
    </Link>
  ) : (
    <div className={styles.container}>{children}</div>
  );
};

ContentMapColumnHeader.propTypes = propTypes;
ContentMapColumnHeader.defaultProps = defaultProps;

export default ContentMapColumnHeader;
